'use client';

import { useEffect, useState } from 'react';
import styles from './archival-label-viewer.module.scss';
import CloseButton from 'assets/icons/close-x.svg';
import ChevronL from 'assets/icons/chevron-l.svg';
import { ObjectAsLauderArchivalLabel } from './object-as-archival-label';
import { type IObjectAsLauderArchivalLabel } from '@metmuseum/types';

interface IProps {
	handleCloseClick: () => void;
	archivalLabels: IObjectAsLauderArchivalLabel[];
	initialActiveObjectIndex: number;
}

export const ArchivalLabelViewer = (props: IProps) => {
	const { handleCloseClick, archivalLabels, initialActiveObjectIndex } = props;
	const [activeObjectIndex, setActiveObjectIndex] = useState(
		initialActiveObjectIndex,
	);

	const forwardDisabled = activeObjectIndex === archivalLabels.length - 1;
	const prevDisabled = activeObjectIndex === 0;

	const handleForwardClick = () => {
		setActiveObjectIndex(activeObjectIndex + 1);
	};

	const handlePrevClick = () => {
		setActiveObjectIndex(activeObjectIndex - 1);
	};

	useEffect(() => {
		const handleKeyDown = (e) => {
			e = e || window.event;
			if (e.keyCode == '37') {
				!prevDisabled && setActiveObjectIndex(activeObjectIndex - 1);
			} else if (e.keyCode == '39') {
				!forwardDisabled && setActiveObjectIndex(activeObjectIndex + 1);
			} else if (e.key == 'Escape') {
				handleCloseClick();
			}
		};
		document.addEventListener('keydown', handleKeyDown);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [prevDisabled, forwardDisabled, activeObjectIndex, handleCloseClick]);

	return (
		<div
			className={`
			${styles.container}
			${styles.isFullscreen}
			playwright-archival-label-modal
		`}
		>
			<button
				className={`${styles.close} playwright-modal-close-button`}
				onClick={handleCloseClick}
			>
				<CloseButton />
			</button>
			<ObjectAsLauderArchivalLabel
				key={archivalLabels[activeObjectIndex].objectID}
				archivalLabel={archivalLabels[activeObjectIndex]}
			/>
			<button
				disabled={prevDisabled}
				onClick={handlePrevClick}
				className={`
					${styles.back}
					${styles.arrow}
					${prevDisabled && styles.isDisabled}
				`}
			>
				<ChevronL />
			</button>
			<button
				disabled={forwardDisabled}
				onClick={handleForwardClick}
				className={`
					${styles.forward}
					${styles.arrow}
					${forwardDisabled && styles.isDisabled}
				`}
			>
				<ChevronL />
			</button>
		</div>
	);
};
